import { SnackBarProps } from "../components/SnackBar";

export const SNACKBAR_SUBSCRIBERS = new Set<(p: SnackBarProps) => void>();

export function notifySnackbar(arg: { message: string }) {
  for (const sub of SNACKBAR_SUBSCRIBERS) {
    sub({ message: arg.message, open: true });
  }
}
